import { render, staticRenderFns } from "./VideoComp.vue?vue&type=template&id=30ecfaec&scoped=true&"
import script from "./VideoComp.vue?vue&type=script&lang=js&"
export * from "./VideoComp.vue?vue&type=script&lang=js&"
import style0 from "./VideoComp.vue?vue&type=style&index=0&id=30ecfaec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ecfaec",
  null
  
)

export default component.exports